export default (state) => state?.plp?.listing?.response?.body?.searchTermView;
